import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
import { downloadFile, getExportErrorMessage } from "../../helpers/exportFile";
const ePaymentTransferApi = factory.get("ePaymentTransfer");
const initialState = {
  searchBody: {},
  dialog: false,
  ePaymentTransfer: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
    total_debt: 0,
  },
  types: {
    loading: false,
    data: [],
  },
};

export const ePaymentTransferSlice = createSlice({
  name: "ePaymentTransfer",
  initialState,
  reducers: {
    setDataTable: (state, { payload }) => {
      state.ePaymentTransfer.data = payload.data.data;
      state.ePaymentTransfer.total = payload.data.total;
      state.ePaymentTransfer.total_amount = payload.data.total_amount;
      state.ePaymentTransfer.total_debt = payload.data.total_debt;
    },

    setTypes: (state, { payload }) => {
      // Normalized to { id, name } regardless of the raw field names so the
      // selector stays stable if the types payload uses either convention.
      const list = payload.data?.data ?? payload.data ?? [];
      state.types.data = list.map((item) => ({
        id: item.id ?? item.transfer_type_id,
        name: item.name ?? item.transfer_type_name ?? item.value,
      }));
    },

    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },

    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },

    setDialog: (state, { payload }) => {
      state.dialog = payload ?? !state.dialog;
    },
  },
});

export const { setLoading, setDataTable, setTypes, setSearchBody, setDialog } =
  ePaymentTransferSlice.actions;

export default ePaymentTransferSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("ePaymentTransfer"));
    const res = await ePaymentTransferApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("ePaymentTransfer"));
  } catch (err) {
    dispatch(setLoading("ePaymentTransfer"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "An error occurred",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const getTypes = () => async (dispatch) => {
  try {
    dispatch(setLoading("types"));
    const res = await ePaymentTransferApi.getTypes();
    dispatch(setTypes(res));
    dispatch(setLoading("types"));
  } catch (err) {
    dispatch(setLoading("types"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "An error occurred",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const exportExcel = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("ePaymentTransfer"));
    const res = await ePaymentTransferApi.export({
      ...params,
      is_excel: 1,
    });
    await downloadFile(res, `e_payment_transfer.xlsx`);
    dispatch(setLoading("ePaymentTransfer"));
  } catch (err) {
    dispatch(setLoading("ePaymentTransfer"));
    dispatch(
      showNotification({
        message: await getExportErrorMessage(err),
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

const create = (data, searchBody) => async (dispatch) => {
  try {
    dispatch(setLoading("ePaymentTransfer"));
    await ePaymentTransferApi.create(data);
    dispatch(
      showNotification({
        message: "تمت العملية بنجاح",
        type: "success",
      }),
    );
    dispatch(setLoading("ePaymentTransfer"));
    dispatch(setDialog(false));
    dispatch(getAll(searchBody));
  } catch (err) {
    dispatch(setLoading("ePaymentTransfer"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "An error occurred",
        type: "error",
      }),
    );
    throw new Error(err);
  }
};

export const EPaymentTransfer = {
  getAll,
  getTypes,
  exportExcel,
  create,
};
